(()=>{function init(root){if(root.dataset.tzInitialized)return;root.dataset.tzInitialized='true';const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const auto=root.dataset.autoplay==='true'&&!reduce;const interval=Math.max(3000,Number(root.dataset.interval)||6000);
  /* hero parallax: bg drifts slower than text, text lifts + fades */
  (function(){
    if(reduce) return;
    var hero = root.querySelector('[data-tz-hero]');
    if(!hero) return;
    var ticking = false;
    function update(){
      ticking = false;
      var r = hero.getBoundingClientRect();
      if(r.bottom < 0 || r.top > window.innerHeight) return;
      var p = Math.max(0, Math.min(1, -r.top / (r.height || 1)));
      hero.style.setProperty('--tz-hero-y', (p * r.height * 0.28).toFixed(1) + 'px');
      hero.style.setProperty('--tz-hero-ty', (p * r.height * -0.12).toFixed(1) + 'px');
      var inner = hero.querySelector('.tz-boys__hero-inner');
      if(inner) inner.style.opacity = (1 - p * 0.55).toFixed(2);
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    update();
  })();
root.querySelectorAll('[data-tz-carousel]').forEach(carousel=>{const track=carousel.querySelector('[data-tz-track]');const cards=track.querySelectorAll('.tz-boys__product');if(!cards.length)return;const step=()=>cards[0].getBoundingClientRect().width+12;const move=(dir)=>{const end=track.scrollWidth-track.clientWidth;if(dir>0&&track.scrollLeft>=end-5){track.scrollTo({left:0,behavior:'smooth'})}else if(dir<0&&track.scrollLeft<=5){track.scrollTo({left:end,behavior:'smooth'})}else track.scrollBy({left:dir*step(),behavior:'smooth'})};carousel.querySelector('[data-tz-prev]')?.addEventListener('click',()=>move(-1));carousel.querySelector('[data-tz-next]')?.addEventListener('click',()=>move(1));if(!auto||cards.length<3)return;let timer;const stop=()=>{if(timer)clearInterval(timer)};const start=()=>{stop();timer=setInterval(()=>{if(document.hidden||carousel.matches(':hover')||carousel.contains(document.activeElement))return;move(1)},interval)};carousel.addEventListener('mouseenter',stop);carousel.addEventListener('mouseleave',start);carousel.addEventListener('focusin',stop);carousel.addEventListener('focusout',start);start();root.addEventListener('shopify:section:unload',stop,{once:true})})}
  /* category rectangles auto-rotate */
  root.querySelectorAll('[data-tz-catrotate]').forEach(function(row){
    if(reduce) return;
    var cards = row.querySelectorAll('.tz-boys__category-card');
    if(cards.length < 3) return;
    var timer;
    function step(){
      var w = cards[0].getBoundingClientRect().width + 14;
      var end = row.scrollWidth - row.clientWidth;
      if(row.scrollLeft >= end - 8){ row.scrollTo({left:0,behavior:'smooth'}); }
      else { row.scrollBy({left:w,behavior:'smooth'}); }
    }
    function start(){ stop(); timer = setInterval(function(){
      if(document.hidden || row.matches(':hover')) return;
      step();
    }, 3200); }
    function stop(){ if(timer) clearInterval(timer); }
    row.addEventListener('mouseenter', stop);
    row.addEventListener('mouseleave', start);
    row.addEventListener('touchstart', stop, {passive:true});
    start();
  });

document.querySelectorAll('[data-tz-boys]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-tz-boys]').forEach(init))})();
